export { productEnvToCdnEnv, createSrcFromExtension } from './createSrcFromExtension';
export { shortenUuid, expandUuid } from '../../../utils/forgeAppCdnOrigin';
export { getSrcUrl, isTunnelSrc } from './getSrcUrl';
export { getBrowserLocale } from './getBrowserLocale';
export { getResolverContext } from './getResolverContext';
export { getViewContext } from './getViewContext';
export { parseContextAri, type ContextAri, type Installation } from './parseContextAri';
export { selectOptimalInvocationResponse } from './tokenComparison';
export { useCDNAuthSignedCookie, shouldUseCDNAuth } from './useCDNAuthSignedCookie';

export const getBrowserTimezone = (): string => {
	return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
